import { render } from "./MessageActionForm.vue?vue&type=template&id=fd2d1bb4"
import script from "./MessageActionForm.vue?vue&type=script&lang=js"
export * from "./MessageActionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__